<template>
    <div v-if="$store.state.connected" class="dashboard">
        <Dashboard />
    </div>
</template>

<script>
    import Dashboard from "@/components/Dashboard/Dashboard.vue";
    import router from "../router/index.js";
    
    export default {
        name: "Home",
        data(){
            return{
            }
        },
        components: {
            Dashboard,
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>